import React from 'react';
import {
    HomeFilled,
    HomeOutlined,
    GameFilled,
    GameOutlined,
    NotiOutlined,
    NotiFilled,
    ProfileOutlined,
    SpinFilled,
} from '@assets';
import {
    Container,
    ItemWrapper,
    Label,
} from './BottomNavigator.style';
import { useLocation, useNavigate } from 'react-router-dom';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { useTranslation } from "react-i18next";
import { localStorage } from '@utils';

const Item = ({
    path,
    label,
    icon,
    icon_active,
    is_home,
}) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const is_active = pathname.includes(path);
    const userPreferedLanguage = localStorage.getUserPreferedLanguage();

    const handleClicked = (path, is_home) => {
        const _path = is_home ? path : `/${path}`;
        navigate(_path, { replace: true });
    }

    return (
        <ItemWrapper onClick={() => handleClicked(path, is_home)}>
            {is_active ? icon_active : icon}
            <Label lang={userPreferedLanguage} status={is_active ? 'active' : 'default'}>
                {label}
            </Label>
        </ItemWrapper>
    );
}

const BottomNavigator = () => {
    const { t } = useTranslation()
    const userPreferedLanguage = localStorage.getUserPreferedLanguage();

    const options = [
        {
            path: PUBLIC_ROUTE.POPULAR,
            label: t("bottomNavigator.home"),
            icon: <HomeOutlined />,
            icon_active: <HomeFilled />,
            is_home: true,
        },
        {
            path: PUBLIC_ROUTE.GAMES,
            label: t("bottomNavigator.game"),
            icon: <GameOutlined />,
            icon_active: <GameFilled />,
            is_home: true,
        },
        {
            path: PUBLIC_ROUTE.SPIN_HOME,
            icon: <SpinFilled />,
            is_home: false,
        },
        {
            path: PUBLIC_ROUTE.NOTIFICATION,
            label: t("bottomNavigator.notification"),
            icon: <NotiOutlined />,
            icon_active: <NotiFilled />,
            is_home: true,
        },
        {
            path: PUBLIC_ROUTE.PROFILE,
            label: t("bottomNavigator.profile"),
            icon: <ProfileOutlined />,
            is_home: false,
        },
    ];

    return (
        <Container lang={userPreferedLanguage}>
            {options.map((item, key) => (
                <Item
                    key={key}
                    path={item.path}
                    label={item.label}
                    icon={item.icon}
                    icon_active={item.icon_active}
                    is_home={item.is_home}
                />
            ))}
        </Container>
    );
}

export default BottomNavigator;